var HomeView = $.extend({/* HomeView */}, BaseView, {

	viewSelector: '#home-view',

	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {

	}
})